'use strict';

const PdfPreviewActions = function PdfPreviewActions (Flux, APP_DISPATCHER_ID) {

  const Actions = Flux.Actions.create('PdfPreviewActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'ShowPdfPreview',
    purpose: 'Show site selector dialog',
    payload: []
  });

  Actions.add({
    name: 'HidePdfPreview',
    purpose: 'Hide site selector dialog',
    payload: []
  });

  Actions.add({
    name: 'ShowPdfCancelDialog',
    purpose: 'Show site selector dialog',
    payload: ['promise']
  });

  Actions.add({
    name: 'ProcessPdf',
    purpose: 'Send PDF information to octo-worker for processing',
    payload: ['data']
  });

  Actions.add({
    name: 'CancelDownload',
    purpose: 'Cancel PDF download after it has begun processing',
    payload: []
  });

  return Actions;
};

PdfPreviewActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];

module.exports = PdfPreviewActions;



// WEBPACK FOOTER //
// ./src/app/shared/pdfPreview/PdfPreviewActions.js